// Attachment safety helpers (client-side UI warning only)
export function getFileExtLower(name: string): string {
  const s = (name ?? "").trim();
  const i = s.lastIndexOf(".");
  if (i <= 0 || i === s.length - 1) return "";
  return s.slice(i + 1).toLowerCase();
}

const RISKY_EXT = new Set([
  "exe","msi","scr","bat","cmd","com",
  "ps1","psm1","vbs","vbe","js","jse","wsf",
  "jar","apk","reg","lnk","iso","img"
]);

export function isRiskyAttachmentFilename(name: string): boolean {
  const ext = getFileExtLower(name);
  return ext.length > 0 && RISKY_EXT.has(ext);
}
